import { useRef, useCallback } from 'react';

const ExpandableInput = ({
  value = '',
  onChange = () => { },
  onSend = () => { },
  onKeyPress = () => { }
}) => {
  const textareaRef = useRef(null);

  const adjustHeight = useCallback((el) => {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 200) + 'px';
  }, []);

  const handleInput = (e) => {
    onChange(e.target.value);
    adjustHeight(e.target);
  };

  const handleKeyDown = (e) => {
    onKeyPress(e);

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (value.trim()) {
        onSend(value);
        // Reset height after sending
        if (textareaRef.current) {
          textareaRef.current.style.height = 'auto';
        }
      }
    }
  };

  // Set ref and initial height
  const setRef = useCallback((el) => {
    textareaRef.current = el;
    if (el) {
      el.style.height = 'auto';
    }
  }, []);

  return (
    <textarea
      ref={setRef}
      className="customTextArea"
      rows={1}
      value={value}
      onInput={handleInput}
      onChange={handleInput}
      onKeyDown={handleKeyDown}
      placeholder="Type your message here"
      style={{ paddingRight: 50 }}
    />
  );
};

export default ExpandableInput;
